import React, { useEffect } from "react";
import RegisterForm from "./components/RegisterForm";
import { SubmissionError } from "redux-form";
import { useDispatch } from "react-redux";
import { clearValues, submitRegister } from "./actions";
import { Link } from "react-router-dom";
import actions from "redux/actions";

const Register = ({ history }) => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(clearValues());
	}, []);

	const onSubmit = data => {
		dispatch(
			submitRegister(data, err => {
				if (err) {
					throw new SubmissionError(err);
				} else {
					dispatch(
						actions.login.setValue({
							message:
								"Cadastro realizado com sucesso, faça login e preencha as informações adicionais"
						})
					);
					history.push("/login");
				}
			})
		);
	};

	return (
		<div className="account">
			<div className="account__wrapper">
				<div className="account__card">
					<div className="account__head">
						<h3 className="account__title">
							<span className="account__logo">
								SUA<span className="account__logo-accent">MEI</span>
							</span>
						</h3>
						<h4 className="account__subhead subhead">Crie sua conta abaixo</h4>
					</div>
					<RegisterForm onSubmit={onSubmit} />
					<div className="account__have-account">
						<p>
							Já tem conta? <Link to="/login">Entre aqui</Link>
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Register;
